/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PURGE } from 'redux-persist';
import { ButtonTheme } from 'common/components/buttons/button-theme';

export interface ModalType {
  modalType: string;
  modalProps: ModalProps;
}

export interface ModalProps {
  title: string;
  content: string;
  confirmButtonTheme?: ButtonTheme;
  cancelButtonTheme?: ButtonTheme;
  confirmButtonText?: string;
  cancelButtonText?: string;
  componentId?: string;
  additionalProps?: {
    [key: string]: any;
  };
}

export interface ModalState {
  modalInfo: ModalType;
  isOpen: boolean;
  isLoading: boolean;
}

const initialState: ModalState = {
  modalInfo: {} as ModalType,
  isOpen: false,
  isLoading: false
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (
      state,
      { payload: { modalProps, modalType } }: PayloadAction<ModalType>
    ) => {
      state.modalInfo = {
        modalProps,
        modalType
      };
      state.isOpen = true;
    },
    confirmModal: (
      state,
      payload: PayloadAction<{
        title: string;
        additionalProps?: {
          [key: string]: any;
        };
      }>
    ) => {
      state.isLoading = true;
    },
    closeModal: (state) => {
      state.modalInfo = {} as ModalType;
      state.isOpen = false;
      state.isLoading = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export const selectModal = createSelector(
  (state: RootState) => state.modal,
  (modal) => modal
);

export const { openModal, closeModal, confirmModal } = modalSlice.actions;

export default modalSlice.reducer;
